import React, { FC } from 'react';
import styled from 'styled-components';

const _iconsSolid: FC<{ className?: string; fillColor?: string }> = ({ className, fillColor }) => (
    <svg width='52' height='52' viewBox='0 0 52 52' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.125 8.12109V43.8711H43.875V8.12109H8.125ZM11.375 11.3711H24.375V24.3711H11.375V11.3711ZM27.625 11.3711H40.625V24.3711H27.625V11.3711ZM17.875 14.6211L13 21.1211H22.75L17.875 14.6211ZM30.875 14.6211V21.1211H37.375V14.6211H30.875ZM11.375 27.6211H24.375V40.6211H11.375V27.6211ZM27.625 27.6211H40.625V40.6211H27.625V27.6211ZM34.125 29.2461L30.875 34.1211L34.125 38.9961L37.375 34.1211L34.125 29.2461ZM17.875 30.8711C16.0786 30.8711 14.625 32.3247 14.625 34.1211C14.625 35.9175 16.0786 37.3711 17.875 37.3711C19.6714 37.3711 21.125 35.9175 21.125 34.1211C21.125 32.3247 19.6714 30.8711 17.875 30.8711Z'
            fill='white'
        />
    </svg>
);

const IconsSolid = styled(_iconsSolid)``;
export default IconsSolid;
